export default __webpack_public_path__ + "9c449762c08f14d4973e9b8a00f4e388.svg";